<template>
  <!--
    Shown when /version.json names a newer build than this tab is running.
    App.vue renders one of three layouts (admin, legacy, v3 operator), so this
    has to be placed in each of them; it used to live only in the operator one,
    and admins never saw a deploy announced.
  -->
  <v-snackbar :model-value="modelValue" color="info" :timeout="-1" location="bottom right" class="ma-4">
    <div class="d-flex align-center ga-3">
      <v-icon icon="mdi-cloud-download" color="white"></v-icon>
      <div>
        <strong>New version available!</strong>
        <div class="text-caption text-grey-lighten-2">Refresh to load the latest updates.</div>
      </div>
    </div>
    <template v-slot:actions>
      <v-btn color="white" variant="elevated" size="small" class="text-info font-weight-bold" @click="emit('refresh')">
        Refresh
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
});

const emit = defineEmits(['refresh']);
</script>
